import globalStore from "/globalStore.js";

/**
 * Token based authentication, where the auth token is passed in
 * via the URL (e.g. for "/go/*" routes and "?print" URLs).
 */
const tokenAuthentication = {
	authenticate(vueAppRoot, authToken, callback)
	{
		var _this = this;

		console.log("tokenAuthentication.authenticate(): authToken=", authToken);

// 		var debugData = {
// 			authToken: authToken
// 		};
// 		vueAppRoot.recordDebugLog(
// {
// 				source: "tokenAuthentication.authenticate():1", 
// 				data: debugData, 
// 				detailsString: "", 
// 				log: "", 
// 				subType: "", 
// 				item1: "", 
// 				item2: "", 
// 				item3: "", 
// 				item4: ""
// 			}
// 		);



		// Perform an authentication on the token and retrieve the user data to setup the login session.
		var requestData = {
			authToken: authToken
		};
		vueAppRoot.callApi2WithOverlay("POST", "/Authenticate/LoginUserByAuthToken", requestData)
		.then((responseData) => {
			if (responseData == null) return;	// Not succssful
			
			if (responseData.AuthenticateUserResponse.IsAuthenticated == true)
			{
				// Successful login.
				console.log("tokenAuthentication.authenticate():onLogin(): successful login with auth token");

				_this.loginSuccess(responseData);

				if (callback) callback(true, responseData);
			}
			else
			{
				// Invalid credentials.
				console.log("tokenAuthentication.authenticate():onLogin(): failed login with auth token");

				//TODO: Show a not authorised page. But... also need to figure out a sequence to help the use recover (i.e. login to the site)

				if (callback) callback(false, responseData);
			}
		});
	},



	//NOTE: Directly adapted from /unauthenticated/login-form
	/**
	 * Perform action after a successful login.
	 */
	loginSuccess(responseData)	//, targetId)
	{
		console.log("tokenAuthentication.loginSuccess(): globalStore.state.currentUser[BEFORE]=", globalStore.state.currentUser);

		// Store the user's AuthKey, ID and permissions, etc.
		// Reset the existing user first.
		// Keep this in sync with /account-admin/users-page.vue::aliasLogin();
		globalStore.currentUser.clearCurrentUser();

		const authenticateUserResponse = responseData.AuthenticateUserResponse;
		globalStore.currentUser.setCurrentUser(authenticateUserResponse.NextAuthToken, 
			authenticateUserResponse.UserID, 
			authenticateUserResponse.FirstName, 
			authenticateUserResponse.LastName, 
			authenticateUserResponse.DisplayName, 
			authenticateUserResponse.ActiveAccountID, 
			"",	//TODO: Implement "activeClientId"
			"",	//TODO: Implement "activeClientDisplayName"
			authenticateUserResponse.CompleteAccessStructure,
			authenticateUserResponse.IsLotusAccount,
			this.rememberMe);

		console.log("tokenAuthentication.loginSuccess(): globalStore.state.currentUser[AFTER]=", globalStore.state.currentUser);
	},





	isAuthTokenValid(authToken)
	{
		//TODO: implement
		console.error("tokenAuthentication.isAuthTokenValid() is not implemented");
		
		// let promise = new Promise(function(resolve, reject) {	
		
		// 	var requestData = {
		// 		authToken: authToken
		// 	};


		// 	_this.callApi1("POST", "/Authenticate/ValidateAuthToken", requestData)
		// 	.then((responseData) => {
		// 		// console.log("app.validateAuthToken(" + authToken + "): responseData=", responseData);

		// 		if (responseData == null) 
		// 		{
		// 			resolve(null); // Not successful
		// 		}
		// 		else
		// 		{
		// 			resolve(responseData);
		// 		}
		// 	});

		// });

		// return promise;

		return true;	//TODO: Just for testing.
	},
};

export default tokenAuthentication;